import React from 'react';

import { useIntl } from 'react-intl';

import AutoDismissFlag from '@atlaskit/flag/auto-dismiss-flag';
import { FlagGroup } from '@atlaskit/flag/flag-group';
import StatusSuccessIcon from '@atlaskit/icon/core/status-success';
import { token } from '@atlaskit/tokens';

import { messages } from './messages';

type DefinitionUpdateConfirmationFlagType = {
	onDismissed: () => void;
	testId?: string;
};

export const DefinitionUpdateConfirmationFlag: React.FC<DefinitionUpdateConfirmationFlagType> = ({
	onDismissed,
	testId,
}) => {
	const { formatMessage } = useIntl();

	return (
		<FlagGroup onDismissed={() => onDismissed()}>
			<AutoDismissFlag
				id="definition-update-success-adflag"
				title={formatMessage(messages.edit_definition_update_confirmation_title)}
				description={formatMessage(messages.edit_definition_update_confirmation_description)}
				icon={<StatusSuccessIcon label="Success" color={token('color.icon.success')} />}
				testId={testId}
			/>
		</FlagGroup>
	);
};
